isAccountCancelOfferPage